<div class="filter__buttonHolder">
  <button
    class="button overlay__close filter__overlayButton"
    (click)="eventEmit()"
  >
    {{
      (items$ | async)?.length || 0
        | messageformat
          : [resultatenButtonLabel, resultatenButtonReplacementString]
    }}
  </button>
</div>
